// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Vector3 } from './vector3';


export class Polyline {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Polyline {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPolyline(bb:flatbuffers.ByteBuffer, obj?:Polyline):Polyline {
  return (obj || new Polyline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPolyline(bb:flatbuffers.ByteBuffer, obj?:Polyline):Polyline {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Polyline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

points(index: number, obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new Vector3()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 24, this.bb!) : null;
}

pointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startPolyline(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addPoints(builder:flatbuffers.Builder, pointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, pointsOffset, 0);
}

static startPointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(24, numElems, 8);
}

static endPolyline(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPolyline(builder:flatbuffers.Builder, pointsOffset:flatbuffers.Offset):flatbuffers.Offset {
  Polyline.startPolyline(builder);
  Polyline.addPoints(builder, pointsOffset);
  return Polyline.endPolyline(builder);
}
}
